import apiClient from '../../helpers/apiClient';
import { generateQueryString, objectForReq } from '../../helpers/articleHelpers';
import { authHeader } from '../../helpers/authHelpers';

export const GET_EVENTS_INIT = 'GET_EVENTS_INIT';
export const GET_EVENTS_START = 'GET_EVENTS_START';
export const GET_EVENTS_ERROR = 'GET_EVENTS_ERROR';
export const GET_EVENTS = 'GET_EVENTS';

export const LOAD_MORE_EVENTS_START = 'LOAD_MORE_EVENTS_START';
export const LOAD_MORE_EVENTS_ERROR = 'LOAD_MORE_EVENTS_ERROR';
export const LOAD_MORE_EVENTS = 'LOAD_MORE_EVENTS';

export const EVENTS_CONSTANT_FILTERS_INIT = 'EVENTS_CONSTANT_FILTERS_INIT';
export const EVENTS_APPLY_FILTERS_INIT = 'EVENTS_APPLY_FILTERS_INIT';
export const EVENTS_APPLY_FILTERS_START = 'EVENTS_APPLY_FILTERS_START';
export const EVENTS_APPLY_FILTERS_ERROR = 'EVENTS_APPLY_FILTERS_ERROR';
export const EVENTS_APPLY_FILTERS_UPDATE = 'EVENTS_APPLY_FILTERS_UPDATE';
export const EVENTS_APPLY_FILTERS_RESET = 'EVENTS_APPLY_FILTERS_RESET';
export const EVENTS_APPLY_FILTERS = 'EVENTS_APPLY_FILTERS';

export const ADDRESS_RESULTS = 'ADDRESS_RESULTS';
export const ADDRESS_SELECTED = 'ADDRESS_SELECTED';

export const EVENT_SIGNUP_TOGGLE = 'EVENT_SIGNUP_TOGGLE';
export const EVENT_SIGNUP_SUBMITTED = 'EVENT_SIGNUP_SUBMITTED';

export const getTypes = (type) => {
  switch (type) {
    case 'filter':
      return {
        start: EVENTS_APPLY_FILTERS_START,
        error: EVENTS_APPLY_FILTERS_ERROR,
        init: EVENTS_APPLY_FILTERS_INIT,
        action: EVENTS_APPLY_FILTERS,
      };
    case 'loadmore':
      return {
        start: LOAD_MORE_EVENTS_START,
        error: LOAD_MORE_EVENTS_ERROR,
        action: LOAD_MORE_EVENTS,
      };
    case 'constant':
      return {
        init: EVENTS_CONSTANT_FILTERS_INIT,
      };
    default:
      return {
        start: GET_EVENTS_START,
        error: GET_EVENTS_ERROR,
        init: GET_EVENTS_INIT,
        action: GET_EVENTS,
      };
  }
};

export const getEvents =
  ({ endpoint, queryParam = {}, type }) =>
  async (dispatch, getState) => {
    const { page, events } = getState();
    const {
      pageData: { context },
    } = page;
    const { constantFilters, appliedFilters, eventListing } = events;
    const types = getTypes(type);
    const pageStart = type === 'loadmore' ? { pageStart: eventListing.length || 0 } : {};

    const filterObject = {
      ...constantFilters,
      ...appliedFilters,
      ...queryParam,
      ...pageStart,
      context,
    };
    const requestObject = objectForReq(filterObject);

    dispatch({ type: types.start });

    apiClient
      .post(
        endpoint,
        { ...requestObject },
        { headers: authHeader('U0pQOlBhcnRuZXI=', 'application/json') },
      )
      .then((res) => {
        const data = res?.data || null;
        if (data !== null) {
          dispatch({
            type: types.action,
            payload: data,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: types.error });
      });
  };

export const filterInital = (obj, type) => async (dispatch) => {
  const TYPE = getTypes(type);

  dispatch({
    type: TYPE.init,
    payload: obj,
  });
};

export const updateFilter = (data) => async (dispatch, getState) => {
  const { appliedFilters } = getState().events;

  if (data) {
    dispatch({
      type: EVENTS_APPLY_FILTERS_UPDATE,
      payload: data,
    });
  }

  let queryString = null;
  if (typeof data === 'object') {
    queryString = generateQueryString({ ...appliedFilters, ...data });
  }

  queryString = queryString === null ? window.location.pathname : queryString;
  // updates end of url with new generated slug
  window.history.replaceState(null, null, queryString);
};

export const resetFilters = () => async (dispatch) => {
  dispatch({
    type: EVENTS_APPLY_FILTERS_RESET,
  });

  window.history.replaceState(null, null, window.location.pathname);
};

export const addressResultUpdate = (results) => async (dispatch) => {
  dispatch({
    type: ADDRESS_RESULTS,
    payload: results,
  });
};

export const addressSelectedUpdate = (obj) => async (dispatch) => {
  dispatch({
    type: ADDRESS_SELECTED,
    payload: obj,
  });
};

export const eventSignupToggle = (bool) => async (dispatch) => {
  dispatch({
    type: EVENT_SIGNUP_TOGGLE,
    payload: bool,
  });
};

export const eventSignupSubmitted = (bool) => async (dispatch) => {
  dispatch({
    type: EVENT_SIGNUP_SUBMITTED,
    payload: bool,
  });
};
